import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IErrorResponse, QueryKeys } from "../../querys/querys.enum";
import axiosInstance from "../../../utils/axios";
import {
  UsersWithFcmTokenParams,
  UsersWithFcmTokenResponse,
} from "../../../models/Interface/NotificationManagement.interface";

/**
 * GET /notifications-management/users-with-fcm-token — permission: `get:users:with:fcm:token`
 *
 * A user showing up here is reachable: they exist and hold an FCM token.
 */
const useUsersWithFcmToken = (
  params: UsersWithFcmTokenParams,
  enabled = true
) => {
  return useQuery<UsersWithFcmTokenResponse, AxiosError<IErrorResponse>>({
    queryKey: [QueryKeys.USERS_WITH_FCM_TOKEN, params],
    queryFn: async () => {
      const search = new URLSearchParams();
      search.append("page", String(params.page ?? 1));
      search.append("limit", String(params.limit ?? 50));
      if (params.email?.trim()) {
        search.append("email", params.email.trim());
      }

      return (
        await axiosInstance.get(
          `/notifications-management/users-with-fcm-token?${search.toString()}`
        )
      ).data;
    },
    enabled,
    staleTime: 0,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    retry: 0,
  });
};

export default useUsersWithFcmToken;
